<div class="language-switcher">
    <button mat-button [matMenuTriggerFor]="menu">
        <img [src]="currentFlag" alt="Flag" class="flag-icon" />
        {{ currentLang.toUpperCase() }}
    </button>
    <mat-menu #menu="matMenu">
        <button *ngFor="let lang of languages" mat-menu-item (click)="changeLanguage(lang.code)">
            <img [src]="lang.flag" alt="{{ lang.code }}" class="flag-icon" />
            {{ lang.label }}
        </button>
    </mat-menu>
</div>